import { Fragment, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectConfirmBoxes } from 'store/actions'
import { closeConfirmBox } from 'store/actions/confirmBox'

import ConfirmBoxBasic from 'components/ConfirmBoxBasic'

import ConfirmBoxUnfollow from './ConfirmBoxUnfollow'
import ConfirmBoxJoinGroupBeforeAction from './ConfirmBoxJoinGroupBeforeAction'
import ConfirmBoxUnPinPost from './ConfirmBoxUnPinPost'
import ConfirmBoxBlockUser from './ConfirmBoxBlockUser'
import ConfirmBoxDetectBanWord from './ConfirmBoxDetectBanWord'
import ConfirmBoxModeratorOffer from './ConfirmBoxModeratorOffer'
import ConfirmBoxGroupOwnerOffer from './ConfirmBoxGroupOwnerTransfer'
import ConfirmBoxVipFeature from './ConfirmBoxVipFeature'
import ConfirmBoxMovePostToThread from './ConfirmBoxMovePostToThread'

import { CONFIRM_BOX } from './config'

const GlobalConfirmBox = () => {
  const dispatch = useDispatch()
  const confirmBoxes = useSelector(selectConfirmBoxes)

  const onClose = useCallback(
    (key, cb = () => {}) =>
      () => {
        dispatch(
          closeConfirmBox({
            key,
          })
        )
        cb()
      },
    [dispatch]
  )

  const generateDefaultProps = useCallback(
    (key) => {
      const confirmBox = confirmBoxes?.[key] || {}

      return {
        isActive: confirmBox?.isActive,
        data: confirmBox?.data,
        ...(confirmBox?.confirmBoxProps || {}),
        onClose: onClose(key, confirmBox?.confirmBoxProps?.onClose),
        onOk: onClose(key, confirmBox?.confirmBoxProps?.onOk),
        ...(confirmBox?.confirmBoxProps?.cancelText
          ? { onCancel: onClose(key, confirmBox?.confirmBoxProps?.onCancel) }
          : {}),
      }
    },
    [confirmBoxes]
  )

  return (
    <Fragment>
      <ConfirmBoxUnfollow {...generateDefaultProps(CONFIRM_BOX.UNFOLLOW)} />

      <ConfirmBoxJoinGroupBeforeAction
        {...generateDefaultProps(CONFIRM_BOX.JOIN_GROUP_BEFORE_ACTION)}
      />

      <ConfirmBoxUnPinPost {...generateDefaultProps(CONFIRM_BOX.UNPIN_POST)} />
      <ConfirmBoxBlockUser {...generateDefaultProps(CONFIRM_BOX.BLOCK_USER)} />

      <ConfirmBoxDetectBanWord
        {...generateDefaultProps(CONFIRM_BOX.DETECT_BAN_WORD)}
      />

      <ConfirmBoxModeratorOffer
        {...generateDefaultProps(CONFIRM_BOX.GROUP_MODERATOR_OFFER)}
      />

      <ConfirmBoxGroupOwnerOffer
        {...generateDefaultProps(CONFIRM_BOX.GROUP_OWNER_TRANSFER)}
      />

      <ConfirmBoxVipFeature
        {...generateDefaultProps(CONFIRM_BOX.VIP_FEATURE)}
      />

      <ConfirmBoxMovePostToThread
        {...generateDefaultProps(CONFIRM_BOX.MOVE_POST_TO_THREAD)}
      />

      <ConfirmBoxBasic
        {...generateDefaultProps(CONFIRM_BOX.DEFAULT)}
        title={confirmBoxes?.[`${CONFIRM_BOX.DEFAULT}`]?.data?.title}
        content={confirmBoxes?.[`${CONFIRM_BOX.DEFAULT}`]?.data?.content}
      />
    </Fragment>
  )
}

export default GlobalConfirmBox
